import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInterceptor';
import { DateTime } from 'luxon';

import {
    Container, Typography, Divider, Grid, Box, FormControl, FormLabel, Button, CircularProgress,
    TableContainer, Table, TableHead, TableRow, TableCell, TableBody,
} from '@mui/material'

import { useTheme } from '@mui/material/styles'

import { DatePicker } from '@mui/x-date-pickers';

import useWindowDimensions from '../../utils/functions/useWindowDimensions';

import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    Cell
} from "recharts";

import {
    Radar,
    RadarChart,
    PolarGrid,
    PolarAngleAxis,
    PolarRadiusAxis,
    PieChart,
    Pie,
} from "recharts";

import { formatMoney, getDate } from '../../utils/functions/Utils';

const Estadisticas = () => {

    const theme = useTheme()

    let navigate = useNavigate();
    const auth = useSelector((state) => state.auth);

    const [loading, setLoading] = useState(true);

    const [monthReport, setMonthReport] = useState(DateTime.now());
    const [dataMonth, setDataMonth] = useState({
        gastosClass: [{ nombre: 'Gastos', cantidad: 400 }],
        total: [{ name: 'Gastos', value: 400 },
        { name: 'Ventas', value: 300 }]
    });
    const [data, setData] = useState([{}]);

    const { width } = useWindowDimensions();

    useEffect(() => {
        if (!['Admin'].includes(auth.user.rol)) {
            navigate('/dashboard');
        }
        document.title = 'Estadisticas';
    }, [auth])

    const getData = async () => {
        try {
            setLoading(true);
            const res = await axios.post('/api/orders/yearReport', { month: monthReport.month, year: monthReport.year })
            if (res.status === 200) {
                setData(res.data);
            }
            setLoading(false);
        } catch (err) {
            console.log(err)
            setLoading(false);
        }
    }

    useEffect(() => {
        getData()
    }, [])

    const getData2 = async () => {
        try {
            setLoading(true);
            const res = await axios.post('/api/orders/monthReport', { month: monthReport.month, year: monthReport.year })
            if (res.status === 200) {
                setDataMonth(res.data);
                setLoading(false);
            }
        } catch (err) {
            console.log(err)
            setLoading(false);
        }
    }

    useEffect(() => {
        getData2()
    }, [monthReport])

    const COLORS = ['#00C49FCC', '#FF8042CC'];

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent, index }) => {
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        return (
            <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
                {`${(percent * 100).toFixed(0)}%`}
            </text>
        );
    };

    return (
        <Container maxWidth='xxl' style={{ marginTop: '10px' }}>
            {loading ?
                <Box style={{ display: 'flex', justifyContent: 'center', alignContent: 'center', marginTop: '128px' }}>
                    <CircularProgress size='5em' color='primary' />
                </Box> :
                <>
                    <Container maxWidth='xxl'>
                        <Container maxWidth='xl'>
                            <Typography variant='h4' style={{ fontWeight: 700, textAlign: 'center' }}>Estadisticas</Typography>
                            <Button size='small' variant='outlined' onClick={() => navigate('/informes')}><i className='fad fa-arrow-left'></i> &nbsp;&nbsp;Regresar</Button>

                            <Typography variant='h4' sx={{ fontWeight: 700, mt: 3 }}>Utilidad por mes</Typography>
                            <Typography variant='h6' sx={{ fontWeight: 500, my: 2 }}>Selecciona el mes del reporte</Typography>

                            <DatePicker value={monthReport} onChange={(newValue) => setMonthReport(newValue)} />
                            <Typography variant='h4' sx={{ fontWeight: 500, my: 2, textAlign: 'center' }}>Flujo de {getDate(monthReport, 'MMMM yyyy')}</Typography>


                            <Grid container spacing={2}>
                                <Grid item md={6}>
                                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <PieChart width={width > 600 ? 600 : width - 20}
                                            height={500}>
                                            <Pie
                                                data={dataMonth.total}
                                                cx={width > 600 ? 300 : width / 2}
                                                cy={250}
                                                outerRadius={width > 600 ? 150 : width / 4 - 20}
                                                labelLine={false}
                                                label={renderCustomizedLabel}
                                                fill="#8884d8"
                                                dataKey="value"
                                            >
                                                {dataMonth.total.map((entry, index) => (
                                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                                ))}
                                            </Pie>
                                            <Tooltip labelStyle={{ fontWeight: 500 }}
                                                itemStyle={{ padding: '8px' }}
                                                contentStyle={{ borderRadius: '20px' }} />
                                        </PieChart>
                                    </Box>
                                </Grid>
                                <Grid item md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}>
                                        <Typography variant='h5' style={{ fontWeight: 500 }}>Ingresos: </Typography>
                                        <Typography variant='h3' style={{ fontWeight: 700, margin: '0px 8px' }} color='comp.spColor2'>$ {formatMoney(dataMonth.total[0].value)}</Typography>
                                    </Box>
                                    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}>
                                        <Typography variant='h5' style={{ fontWeight: 500 }}>Gastos: </Typography>
                                        <Typography variant='h3' style={{ fontWeight: 700, margin: '0px 8px' }} color='comp.spColor2'>$ {formatMoney(dataMonth.total[1].value)}</Typography>
                                    </Box>
                                    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}>
                                        <Typography variant='h5' style={{ fontWeight: 500 }}>Ganancia Neta:</Typography>
                                        <Typography variant='h3' style={{ fontWeight: 700, margin: '0px 8px' }} color='comp.spColor2'>$ {formatMoney(dataMonth.balance)}</Typography>
                                    </Box>
                                </Grid>
                            </Grid>

                            <Grid container spacing={1}>
                                <Grid item md={6}>
                                    <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <RadarChart
                                            cx={width > 600 ? 300 : width / 2}
                                            cy={250}
                                            outerRadius={width > 600 ? 150 : width / 4 - 20}
                                            width={width > 600 ? 600 : width - 20}
                                            height={500}
                                            data={dataMonth.gastosClass}
                                        >
                                            <PolarGrid />
                                            <PolarAngleAxis dataKey="nombre" />
                                            <PolarRadiusAxis />
                                            <Radar
                                                name="Cantidad"
                                                dataKey="cantidad"
                                                stroke={theme.palette.info.main}
                                                fill={theme.palette.secondary.main}
                                                fillOpacity={0.6}
                                            />
                                            <Tooltip
                                                labelStyle={{ fontWeight: 500, padding: '8px' }}
                                                itemStyle={{ padding: '8px' }}
                                                contentStyle={{ background: `${theme.palette.background.default}`, borderRadius: '20px' }}
                                            />
                                            <Legend />
                                        </RadarChart>
                                    </Box>
                                </Grid>
                                <Grid item md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                {/* Encabezado para las columnas: 'Categoría' y 'Cantidad' */}
                                                <TableRow hover sx={{ backgroundColor: 'comp.tableHeaderBg' }}>
                                                    <TableCell align='left' sx={{ fontWeight: '400', fontSize: '1em' }}>Categoría</TableCell>
                                                    <TableCell align='center' sx={{ fontWeight: '400', fontSize: '1em' }}>Cantidad</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {/* Iteramos sobre el array dataMonth.gastosClass para crear las filas */}
                                                {dataMonth.gastosClass.map((cat, i) => (
                                                    // Cada elemento (categoría) se convierte en una fila
                                                    <TableRow key={i} hover sx={{ backgroundColor: 'comp.tableBg' }}>
                                                        {/* Primera celda: Nombre de la categoría */}
                                                        <TableCell size='small' sx={{ fontWeight: '700', fontSize: '1em' }} align='left'>
                                                            {cat.nombre}
                                                        </TableCell>
                                                        {/* Segunda celda: Cantidad del gasto */}
                                                        <TableCell size='small' sx={{ fontWeight: '700', fontSize: '1.4em' }} align='center'>
                                                            $ {formatMoney(cat.cantidad)}
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>

                            <Typography variant='h4' sx={{ fontWeight: 500, my: 2, textAlign: 'center' }}>Utilidad de {getDate(monthReport, 'MMMM yyyy')}</Typography>

                            <Grid container spacing={1}>
                                <Grid item md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}>
                                        <Typography variant='h5' style={{ fontWeight: 500 }}>Ingresos: </Typography>
                                        <Typography variant='h3' style={{ fontWeight: 700, margin: '0px 8px' }} color='comp.spColor2'>$ {formatMoney(dataMonth.total[0].value)}</Typography>
                                    </Box>
                                    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}>
                                        <Typography variant='h5' style={{ fontWeight: 500 }}>Costo de ventas: </Typography>
                                        <Typography variant='h3' style={{ fontWeight: 700, margin: '0px 8px' }} color='comp.spColor2'>$ {formatMoney(dataMonth.costoDeVentas)}</Typography>
                                    </Box>
                                    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}>
                                        <Typography variant='h5' style={{ fontWeight: 500 }}>Margen Bruto: </Typography>
                                        <Typography variant='h3' style={{ fontWeight: 700, margin: '0px 8px' }} color='comp.spColor2'>$ {formatMoney(dataMonth.margenBruto)}</Typography>
                                    </Box>
                                </Grid>
                                <Grid item md={6} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
                                    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}>
                                        <Typography variant='h5' style={{ fontWeight: 500 }}>Gastos operativos: </Typography>
                                        <Typography variant='h3' style={{ fontWeight: 700, margin: '0px 8px' }} color='comp.spColor2'>$ {formatMoney(dataMonth.gastosOperativos)}</Typography>
                                    </Box>
                                    <Box style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', marginTop: '24px' }}>
                                        <Typography variant='h5' style={{ fontWeight: 500 }}>Margen operativo: </Typography>
                                        <Typography variant='h3' style={{ fontWeight: 700, margin: '0px 8px' }} color='comp.spColor2'>$ {formatMoney(dataMonth.margenOperativo)}</Typography>
                                    </Box>
                                </Grid>
                            </Grid>

                        </Container>

                        <br />

                        <Typography variant='h4' sx={{ fontWeight: 500, my: 2, textAlign: 'center' }}>Flujo de los ultimos 12 meses</Typography>

                        <Container maxWidth='xxl'>
                            <Box
                                style={{
                                    display: 'flex',
                                    justifyContent: 'center'
                                }}>
                                <BarChart
                                    width={width > 600 ? width - 100 : width - 20}
                                    height={700}
                                    data={data}
                                    margin={{
                                        top: 20,
                                        right: 30,
                                        left: 20,
                                        bottom: 5,
                                    }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis dataKey="name" />
                                    <YAxis />
                                    <Tooltip
                                        labelStyle={{ fontWeight: 500, padding: '8px' }}
                                        itemStyle={{ padding: '8px' }}
                                        contentStyle={{ background: `${theme.palette.background.default}`, borderRadius: '20px' }}
                                    />
                                    <Legend />
                                    <Bar dataKey="Ingresos" stackId="a" fill='#00C49FCC' />
                                    <Bar dataKey="Gastos" stackId="a" fill='#FF8042CC' />
                                </BarChart>
                            </Box>
                        </Container>

                    </Container>
                </>
            }

        </Container>
    )
}

export default Estadisticas